<select [formControl]="frmGrp.get(name)">
    <option *ngFor="let o of options" [value]="o">{{o}}</option>
</select>
